<template>
  <div id="pageItemList">
    <page-header></page-header>
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                :placeholder="$t('fulltextSearch')"
                v-model="searchInput"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-toolbar-items>
                <v-btn flat icon @click="filterYear--">
                  <v-icon>arrow_left</v-icon>
                </v-btn>
                <v-text-field
                  prepend-icon="date_range"
                  :label="$t('year')"
                  type="number"
                  v-model="filterYear"
                  :single-line="true"
                ></v-text-field>
                <v-btn flat icon @click="filterYear++">
                  <v-icon>arrow_right</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="serviceReports"
                :rows-per-page-items="[10, 25, 50]"
                :pagination.sync="pagination"
                :total-items="serviceReportsCount"
                :loading="serviceReportIsLoading"
                class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.rma }}</td>
                  <td>
                    <au-vehicle :vehicle="props.item.vehicle" />
                  </td>
                  <td>
                    <span v-if="props.item.issue">
                      <router-link
                        :to="{
                          name: 'IssueShow',
                          params: { id: props.item.issue.id }
                        }"
                        style="text-decoration: none"
                      >
                        <v-icon small>bug_report</v-icon>
                        {{ props.item.issue.rma }}
                      </router-link>
                    </span>
                    <span v-else class="font-italic">
                      {{ $t("lack") }}
                    </span>
                  </td>
                  <td>
                    {{ props.item.component.name }}
                  </td>
                  <td>
                    <action-tooltip
                      icon="details"
                      color="primary"
                      :tooltip="$t('details')"
                      :to="{
                        name: 'ServiceReportShow',
                        params: { id: props.item.id }
                      }"
                    ></action-tooltip>
                    <action-tooltip
                      icon="edit"
                      color="info"
                      :tooltip="$t('edit')"
                      :to="{
                        name: 'ServiceReportEdit',
                        params: { id: props.item.id }
                      }"
                      v-if="hasPermission(ROLE_PERMISSION_SERVICE_REPORT_EDIT)"
                    ></action-tooltip>
                    <action-tooltip
                      icon="delete"
                      color="red"
                      :tooltip="$t('delete')"
                      @click="$refs.deleteDialog.deleteAction(props.item)"
                      v-if="
                        hasPermission(ROLE_PERMISSION_SERVICE_REPORT_DELETE)
                      "
                    ></action-tooltip>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <delete-dialog
      messageKey="deleteServiceReport"
      itemKey="rma"
      ref="deleteDialog"
      @confirm="deleteConfirmation"
    ></delete-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import {
  FETCH_SERVICE_REPORTS,
  DELETE_SERVICE_REPORT,
  SHOW_SNACKBAR
} from "@/store/actions.type";
import refreshButtonMixin from "@/mixins/refreshButton.mixin";
import createButtonMixin from "@/mixins/createButton.mixin";
import searchInputMixin from "@/mixins/searchInput.mixin";
import paginationMixin from "@/mixins/pagination.mixin";
import {
  ROLE_PERMISSION_SERVICE_REPORT_EDIT,
  ROLE_PERMISSION_SERVICE_REPORT_DELETE
} from "@/common/permissions";

export default {
  data() {
    return {
      modal: {
        show: false,
        mode: ""
      },
      pagination: {
        sortBy: "rma",
        descending: true
      },
      headers: [
        { text: this.$t("number"), value: "rma" },
        { text: this.$t("vehicle"), value: "vehicle" },
        { text: this.$t("issue"), value: "issue" },
        { text: this.$t("component"), value: "component" },
        { text: this.$t("actions"), sortable: false }
      ],
      ROLE_PERMISSION_SERVICE_REPORT_EDIT: ROLE_PERMISSION_SERVICE_REPORT_EDIT,
      ROLE_PERMISSION_SERVICE_REPORT_DELETE: ROLE_PERMISSION_SERVICE_REPORT_DELETE,
      filterYear: new Date().getFullYear()
    };
  },
  computed: {
    ...mapGetters([
      "serviceReports",
      "serviceReportsCount",
      "serviceReport",
      "serviceReportIsLoading",
      "hasPermission"
    ]),
    createdAtFrom() {
      return this.$moment(`${this.filterYear}-01-01`, "YYYY-MM-DD").format();
    },
    createdAtTo() {
      return this.$moment(`${this.filterYear + 1}-01-01`, "YYYY-MM-DD")
        .subtract(1, "seconds")
        .format();
    }
  },
  watch: {
    filterYear: function() {
      this.fetchItems();
    }
  },
  mixins: [
    refreshButtonMixin,
    createButtonMixin,
    searchInputMixin,
    paginationMixin
  ],
  methods: {
    fetchItems() {
      this.$store.dispatch(FETCH_SERVICE_REPORTS, [
        this.pagination,
        this.search,
        {
          "createdAt:from": this.createdAtFrom,
          "createdAt:to": this.createdAtTo
        }
      ]);
    },
    createAction() {
      this.$router.push({ name: "ServiceReportCreate" });
    },
    deleteConfirmation(serviceReport) {
      this.$store.dispatch(DELETE_SERVICE_REPORT, serviceReport.id).then(() => {
        this.$store.dispatch(SHOW_SNACKBAR, {
          text: this.$t("deletedSuccessfully", [this.$t("serviceReport")]),
          color: "success"
        });

        this.fetchItems();
      });
    }
  }
};
</script>

<style scoped></style>
